import can from 'can';
import FeedDataService from 'scripts/services/timeline-feed-service';
import urlUtil from 'scripts/utils/url';

export const videoHubUrl = globalSettings.pagePaths.video;

export const Playlist = can.Map.extend({
    init: function () {
        this.timelineLoader = new FeedDataService();
    },
    define: {
        activeIndex: {
            type: 'number',
            value: -1
        },
        videos: {
            Type: can.List,
            Value: can.List
        },
        limit: {
            type: 'number',
            value: 5
        },
        offset: {
            type: 'number',
            value: 0
        },
        count: {
            type: 'number',
            value: 99 // fixme
        },
        type: {
            type: 'string',
            value: ''
        },
        activeVideo: {
            set(video) {
                if (!video.isVideoDetail) {
                    // todo remove
                    can.$('html,body').animate({scrollTop: 0}, '500');
                    document.title = video.pageTitle;
                    const targetUrl = `${videoHubUrl}#brightcoveId=${video.brightcoveId}&pageTitle=${encodeURIComponent(video.pageTitle)}&playlist=${this.type}`;
                    const currentUrl = urlUtil.getUrl();
                    const absoluteVideoHubUrl = urlUtil.getAbsoluteURL(videoHubUrl);
                    if (currentUrl === absoluteVideoHubUrl) {
                        $(document).triggerHandler('pushState');
                        urlUtil.pushState(targetUrl);
                    } else {
                        window.location.href = targetUrl;
                    }
                }
                return video;
            }
        }
    },
    nextPage: function () {
        this.attr('offset', this.offset + this.limit);
    },
    prevPage: function () {
        this.attr('offset', this.offset - this.limit);
    },
    canNext: function () {
        return Number(this.attr('offset')) < this.attr('count');
    },
    nextVideo: function () {
        let activeIndex = this.attr('activeIndex');
        if (++activeIndex < this.attr('count')) {
            return this.getVideo(activeIndex).then((video) => {
                this.attr('activeIndex', activeIndex);
                this.attr('activeVideo', video)
            });
        } else {
            return can.Deferred().reject();
        }
    },
    getVideo: function (index) {
        return can.Deferred().resolve(this.videos[index]);
    },
    setVideo: function (index) {
        if (index < this.count) {
            this.getVideo(index).then((video) => {
                this.attr('activeIndex', index);
                this.attr('activeVideo', video);
            })
        }
    },
    setVideoById: function (brightcoveId) {
        for (let i = 0; i < this.videos.length; i++) {
            const video = this.videos[i];
            if (video.brightcoveId === brightcoveId) {
                this.attr('activeIndex', i);
                this.attr('activeVideo', this.videos[i]);
            }
        }
    },
});

export const CategoryPlaylist = Playlist.extend({
    loadVideos: function (limit, offset) {
        if (limit == null) {
            limit = this.attr('limit');
        }
        if (offset == null) {
            offset = this.attr('offset');
        }
        return this.timelineLoader.loadVideoDetail(
            this.attr('type'),
            offset,
            limit
        )
            .then(([newCards, count]) => {
                can.batch.start();
                const videos = this.attr('videos');
                videos.push.apply(videos, newCards);
                this.attr('count', count);
                this.nextPage();
                can.batch.stop();
            }).fail(() => {
                console.log('fail');
            })
    },
    getVideo: function (index) {
        if (index >= this.count) {
            return can.Deferred().reject();
        }
        const videos = this.attr('videos');
        if (!videos[index]) {
            const limit = this.attr('limit');
            const offset = Math.ceil(index / limit) * limit;
            return this.loadVideos(limit, offset)
                .then(() => {
                    return videos[index];
                });
        } else {
            return can.Deferred().resolve(videos[index]);
        }
    },
    setVideoById: function (brightcoveId, pageTitle) {
        this.attr('activeVideo', {
            brightcoveId,
            pageTitle
        });
        this.findVideoIndex(brightcoveId).then((index) => {
            this.attr('activeIndex', index);
        });
    },
    findVideoIndex: function (id) {
        const findIndex = (idToFind) => {
            for (let i = 0; i < this.videos.length; i++) {
                const video = this.videos[i];
                if (video.brightcoveId === idToFind) {
                    return i;
                }
            }
        };
        const d = can.Deferred();

        const tryToFind = () => {
            if (this.canNext()) {
                this.loadVideos(10).then(() => {
                    const videoIndex = findIndex(id);
                    if (videoIndex) {
                        d.resolve(videoIndex);
                    } else {
                        tryToFind();
                    }
                });
            } else {
                d.reject();
            }
        };

        tryToFind();

        return d.promise();
    }
})
